/**
 * Mirrors `ActivityAction` in the API. The API validates this enum on write, so
 * anything missing here renders without an icon or a colour.
 */
export enum ActivityAction {
  CREATE = "CREATE",
  READ = "READ",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  MERGE = "MERGE",
  ASSIGN = "ASSIGN",
  UNASSIGN = "UNASSIGN",
  CONVERT = "CONVERT",
  COMPLETE = "COMPLETE",
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  ATTACH = "ATTACH",
  DETACH = "DETACH",
  INCREMENT_ATTEMPT = "INCREMENT_ATTEMPT",
  MARK_FOR_DELETION = "MARK_FOR_DELETION",
  MARK_FOR_DELETION_UNDO = "MARK_FOR_DELETION_UNDO",
  //
  MOVE_BETWEEN_KANBANS = "MOVE_BETWEEN_KANBANS",
}
